import React, { FC } from 'react';

interface CreditCardProps {
  width?: number;
  height?: number;
  fill?: string;
  classes?: string;
}

const CreditCardIcon: FC<CreditCardProps> = ({
  width = 20,
  height = 20,
  fill = '#424140',
  classes = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={classes}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CreditCardIcon"
    >
      <path
        d="M24 4.80979V19.1902C24 19.8283 23.7789 20.3684 23.3368 20.8105C22.8947 21.2526 22.3546 21.4737 21.7165 21.4737H2.28347C1.64537 21.4737 1.10526 21.2526 0.663158 20.8105C0.221053 20.3684 0 19.8283 0 19.1902V4.80979C0 4.17168 0.221053 3.63158 0.663158 3.18947C1.10526 2.74737 1.64537 2.52631 2.28347 2.52631H21.7165C22.3546 2.52631 22.8947 2.74737 23.3368 3.18947C23.7789 3.63158 24 4.17168 24 4.80979ZM1.89474 7.45768H22.1053V4.80979C22.1053 4.71252 22.0647 4.62347 21.9837 4.54263C21.9028 4.46158 21.8138 4.42105 21.7165 4.42105H2.28347C2.18621 4.42105 2.09716 4.46158 2.01632 4.54263C1.93526 4.62347 1.89474 4.71252 1.89474 4.80979V7.45768ZM1.89474 11.4897V19.1902C1.89474 19.2875 1.93526 19.3765 2.01632 19.4574C2.09716 19.5384 2.18621 19.5789 2.28347 19.5789H21.7165C21.8138 19.5789 21.9028 19.5384 21.9837 19.4574C22.0647 19.3765 22.1053 19.2875 22.1053 19.1902V11.4897H1.89474Z"
        fill={fill}
      />
    </svg>
  );
};

export default CreditCardIcon;
